// extracted by mini-css-extract-plugin
module.exports = {"form":"GladlySearchBox_form__lnlYT","suggestions":"GladlySearchBox_suggestions__Jk5_s","spinner":"GladlySearchBox_spinner__4caJO","spin":"GladlySearchBox_spin__WppYB"};